import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { missingPopup } from "../../helpers/dataHelper/missingData";
import { showNotificationToast, toastify } from "../../helpers/toast/toastify";
import { useSelector } from "react-redux";
import useApi from "../../helpers/apiHelper/requestHelper";
import validator from "validator";
import FloatingTextFiled from "../../pages/sharedPages/CommonComponents/FloatingTextFiled/FloatingTextFiled";
import BubbleSvgButton from "../../pages/sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import eye from "../../assets/images/eye.svg";
import eyeBlock from "../../assets/images/eye-block.svg";

const PASSWORD_RULES = {
  DIGIT: /[0-9]/,
  MIN_LENGTH: 8,
  SPECIAL: /[!@#$%^&*()_+{}[\]:;<>,.?~\\/-]/,
  UPPERCASE: /[A-Z]/,
};

export default function CreatePassword() {
  const api = useApi();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const user = useSelector((state) => state?.user?.user);
  const [validationMessage, setValidationMessage] = useState("");
  const { id } = useParams();

  const handlePasswordChange = (value) => {
    const newPassword = value;
    setPassword(newPassword);

    if (!newPassword) {
      setValidationMessage("");
      return;
    }

    const validations = [
      {
        message: "Password must contain at least one uppercase letter",
        test: PASSWORD_RULES.UPPERCASE.test(newPassword),
      },
      {
        message: `Password must be at least ${PASSWORD_RULES.MIN_LENGTH} characters long`,
        test: validator.isLength(newPassword, { min: PASSWORD_RULES.MIN_LENGTH }),
      },
      {
        message: "Password must contain at least one digit",
        test: PASSWORD_RULES.DIGIT.test(newPassword),
      },
      {
        message: "Password must contain at least one special character",
        test: PASSWORD_RULES.SPECIAL.test(newPassword),
      },
    ];

    const failedValidation = validations.find((v) => !v.test);
    setValidationMessage(failedValidation ? failedValidation.message : "");
  };

  useEffect(() => {
    if (user) {
      if (user?.role === "leader")
        navigate("/leader/dashboard", { replace: true });
      else if (user?.role === "member")
        navigate("/member/dashboard", { replace: true });
      else if (user?.role === "admin") navigate("/admin/dashboard");
    }
  }, [window.location, user]);

  const resetPassword = async () => {
    if (validationMessage !== "") {
      toastify("Please enter a valid password");
      return;
    }
    if (password != confirmPassword) {
      toastify("Passwords do not match");
      return;
    }
    if (!password) {
      missingPopup("Password");
    } else if (!confirmPassword) {
      missingPopup("Confirm Password");
    } else if (password === confirmPassword) {
      const response = await api("post", "auth/resetpassword", {
        otp: id,
        password,
      });
      if (response?.status) {
        showNotificationToast("Password was reset", "");
        // toastify("Password changed successfully.", "success");
        navigate("/login");
      } else {
        toastify(response?.message);
      }
    }
  };

  return (
    <div className="onboardinLayout">
      <div className="onboardingCard">
        <div className="onboardingCardTopBox">
          <p
            className="loginTop"
            onClick={() => {
              navigate("/login");
            }}
          >
            Back to Log In
          </p>
        </div>
        <div className="onboardingCardContentBox">
          <div className="headingBox withHeight">
            <h2 className="title">Create new password</h2>
            <p className="subText">
              Your new password must be different from previously used passwords
            </p>
          </div>
          <div className="inputBox password">
            <FloatingTextFiled
              className={`onboardingInput loginSignUpInput ${password ? "filled" : ""}`}
              forLabel="Password"
              label="Password"
              onChange={(e) => handlePasswordChange(e.target.value)}
              placeholder="Password"
              type={showPassword ? "text" : "password"}
              value={password}
            />
            <button
              className={`eyebtn ${showPassword && "view"}`}
              onClick={() => setShowPassword((pre) => !pre)}
              type="button"
            >
              <img alt="" src={showPassword ? eye : eyeBlock} />
            </button>
          </div>
          {validationMessage && (
            <div style={{ color: "#ff4444", fontSize: "14px", marginTop: "-12px", marginBottom: "12px" }}>
              {validationMessage}
            </div>
          )}
          <div className="inputBox password">
            <FloatingTextFiled
              className={`onboardingInput loginSignUpInput ${confirmPassword ? "filled" : ""}`}
              forLabel="ConfirmPassword"
              label="Verify Password"
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Verify Password"
              type={showConfirmPassword ? "text" : "password"}
              value={confirmPassword}
            />
            <button
              className={`eyebtn ${showConfirmPassword && "view"}`}
              onClick={() => setShowConfirmPassword((pre) => !pre)}
              type="button"
            >
              <img alt="" src={showConfirmPassword ? eye : eyeBlock} />
            </button>
          </div>
          <BubbleSvgButton
            onClick={resetPassword}
            text="Save Password"
            type="button"
            variant="green"
            containerStyling={{
              justifyContent: "center",
            }}
          />
        </div>
      </div>
    </div>
  );
}